module.exports = __webpack_public_path__ + "img/bb.24c05f54.jpg";